
import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import MyWallet from '../../components/MyWallet/MyWallet';
import Chart from '../../components/MyWallet/Chart';

const RewardOptions = (props) => {

    return (
        <Fragment>
            <div className='index_ico page_wrapper'>
                <Header />
                <main className="page_content">
                    {/* <PageTitle pageTitle={'TopCoin UK Units and Value'} pagesub={'Home'} /> */}
                    <PageTitle pageTitle={'TopCoin Rewards Value'} pagesub={'Home'} />
                    <Chart/>
                    <MyWallet/>
                    

                  
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default  RewardOptions;